import { defineStore } from 'pinia';

export const useTableStore = ({ tableName, fetchDataFunction }) =>
	defineStore(`tableStore-${tableName}`, {
		state: () => {
			return {
				loading: false,
				data: [],
				totalRecords: 0,
				lastRequestPagination: {},
				lastRequestFilters: {},
				lastRequestSorters: {},
				nextCursor: null,
				selection: {
					all: false,
					rows: [],
				},
			};
		},
		getters: {
			selectedRows: (state) => state.selection.rows,
		},
		actions: {
			updateSelection(filterFunction) {
				if (!filterFunction) return;
				if (typeof filterFunction != 'function') return;
				this.selection.rows = this.selection.rows.filter(filterFunction);
			},
			updateRow({ rowIdx, newRowData }) {
				this.data[rowIdx] = newRowData;
			},
			deleteRow({ rowIdx }) {
				this.data.splice(rowIdx, 1);
			},
			async fetchData({ pagination, filters, sorters, reverse }, append = false) {
				this.loading = true;
				// console.log('Fetching Table Data', { pagination, filters });
				this.lastRequestPagination = pagination;
				this.lastRequestFilters = filters;
				this.lastRequestSorters = sorters;
				try {
					const { cursor, nextCursor, data, totalRecords } = await fetchDataFunction({
						page: pagination.page,
						per_page: pagination.limit,
						cursor: this.nextCursor,
						filters,
					});

					if (cursor) {
						this.nextCursor = nextCursor;
					}
					if (append) {
						if (reverse) {
							this.data.unshift(...data.reverse());
						} else {
							this.data.push(...data);
						}
					} else {
						this.data = data;
					}
					this.totalRecords = totalRecords;
				} catch (err) {
					console.error(err);
					throw err;
				} finally {
					this.loading = false;
				}
			},
			async exportData(extension, extraData = {}) {
				await fetchDataFunction({
					page: this.lastRequestPagination.page,
					per_page: this.lastRequestPagination.limit,
					filters: this.lastRequestFilters,
					download: 1,
					extension,
					...extraData,
				});
			},
			refetchData() {
				this.fetchData({
					pagination: this.lastRequestPagination,
					filters: this.lastRequestFilters,
					sorters: this.lastRequestSorters,
				});
			},
		},
	})();
